import { render, staticRenderFns } from "./RevisionHistory.vue?vue&type=template&id=1b668bb7&scoped=true"
import script from "./RevisionHistory.vue?vue&type=script&lang=js"
export * from "./RevisionHistory.vue?vue&type=script&lang=js"
import style0 from "./RevisionHistory.vue?vue&type=style&index=0&id=1b668bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b668bb7",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSelect});
